import { Action } from './enum/action';
import { ActiveAuthForm } from './enum/active-auth-form';
import { RegisterRole } from './enum/register-role';
import { User } from './type/user';

export function createSetActiveAuthForm(activeAuthForm: ActiveAuthForm) {
  return {
    type: Action.SET_ACTIVE_FORM,
    payload: {
      activeAuthForm,
    },
  };
}

export function createSetAuthResendTimer(timer?: string) {
  return {
    type: Action.SET_TIMER,
    payload: {
      timer,
    },
  };
}

export function createSetCurrentUser(user?: User) {
  return {
    type: Action.SET_USER,
    payload: {
      user,
    },
  };
}

export function createSetRegisterRole(role: RegisterRole) {
  return {
    type: Action.SET_REGISTER_ROLE,
    payload: {
      role,
    },
  };
}
